import React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';

const LoginRequiredRoute = ({ component: Component, ...rest }) => {
  const isViewMode = rest.location?.pathname?.startsWith('/resume-view-mode') || false;

  return (
    <Route
      {...rest}
      render={(props) => {
        if (isViewMode || rest.loggedIn) {
          return <Component {...props} />;
        }
        return (
          <Redirect
            to={{
              pathname: '/login/',
              state: { from: props.location },
            }}
          />
        );
      }}
    />
  );
};

export default connect((state) => ({
  loggedIn: state.loggedIn,
}))(LoginRequiredRoute);
